import { Link } from "react-router-dom";

const highlights = [
  {
    icon: "ri-live-line",
    title: "热点快速跟进",
    desc: "每日汇总全网热闻线索，第一时间整理成可观看的视频条目。",
  },
  {
    icon: "ri-shield-check-line",
    title: "只讲有据可查",
    desc: "视频内容基于公开信息整理，明确区分事实与讨论，不传播未经证实的内容。",
  },
  {
    icon: "ri-compasses-2-line",
    title: "分类清晰好找",
    desc: "明星动态、网络热议、热门视频、深度解析四大栏目，想看的轻松找到。",
  },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.1fr_1fr] lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-information-line"></i>
              关于黑料视频
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-3xl">
              一个认真做娱乐视频解读的内容站
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              黑料视频创立于 2021 年，从一个专注娱乐八卦剪辑的三人小团队出发，如今已成长为覆盖明星动态、网络热点与影视解析的视频资讯平台。我们相信娱乐新闻也可以做得克制而专业：有观点，但不带节奏；有热度，但更看重事实。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              站内所有视频均为演示内容，用于展示平台的栏目组织、检索与推荐能力。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
              >
                了解更多
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/contact"
                className="flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-send-line"></i>
                内容合作
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-1">
            {highlights.map((item) => (
              <div
                key={item.title}
                className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="text-sm font-bold text-foreground-950 md:text-base">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}